import { css } from '@fable/theme'
import { useStats } from '../../lib/ctx/stats'
import { StatsSectionShareButton } from '../shared'
import { GenresShareCard } from './GenresShareCard'

export const GenresShareButton = () => {
  const theme = useStats((s) => s.theme)

  return (
    <StatsSectionShareButton
      assetStyles={css`
        padding-bottom: 0;
      `}
      sectionBgColor={theme.bg100}
      type="genres"
    >
      <GenresShareCard />
    </StatsSectionShareButton>
  )
}
